import { Component, Inject, DOCUMENT, ChangeDetectionStrategy } from "@angular/core";
import { LoadingBarModule } from "@ngx-loading-bar/core";
import { TmHeaderComponent } from "../header/header.component";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Header, MenuEntry, SideMenu } from "../header/header.type";
import { User, UserService } from "@teammood/shared/util/user";
import { HeaderService } from "../header/header.service";
import { distinctUntilChanged, filter, from, map, mergeMap, tap, pipe } from "rxjs";
import { TmSideMenuComponent } from "./side-menu/side-menu.component";
import { ActivatedRoute, RouterOutlet } from "@angular/router";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TmTopMenuComponent } from "./top-menu/top-menu.component";
import { AsyncPipe, NgClass } from "@angular/common";

@Component({
    selector: 'main',
    imports: [
    LoadingBarModule,
    TmHeaderComponent,
    TmSideMenuComponent,
    TmTopMenuComponent,
    RouterOutlet,
    AsyncPipe,
    NgClass
],
    templateUrl: "main.component.html",
    styleUrls: ['main.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        HeaderService,
    ]
})
export class MainComponent {

    loadingBarColor = getComputedStyle(this.document.body).getPropertyValue('--tm-green').toString();

    protected isHandset$ =  this.breakpointObserver.observe([
        '(max-width: 990px)',
      ]).pipe(
          map(result => result.matches),
          distinctUntilChanged()
      )

    protected header: Header;
    protected sideHeader: SideMenu;
    protected devMode: boolean;
    protected user: User;
    protected teamMoodAdminMenu: MenuEntry[];

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private userService: UserService,
        private headerService: HeaderService,
        private route: ActivatedRoute,
        private breakpointObserver: BreakpointObserver
    ) {

        this.route
            .firstChild // get first child route
            .params.pipe(
                mergeMap(params => {

                    return from(this.userService.get()).pipe(
                        filter(user => !!user),
                        mergeMap(user => {

                            this.user = user;
                            this.devMode = user.isDev;

                            function getTeamId() {
                                // get the team id from the Url
                                const teamIdFromUrl = params['teamId'];
                                const userIsPartOfteamIdFromUrl =
                                    user.teams.filter(team => team.id === teamIdFromUrl || team.id === 'b27ee0b8-7ec0-43b1-9b42-249e991b4bf9').length > 0
                                if (!teamIdFromUrl || !userIsPartOfteamIdFromUrl) {
                                    if (user.teams && user.teamId) {
                                        // if not in Url (/stats or /reporting), get it from the teams
                                        return user.teamId;
                                    } else {
                                        // no active teams for this user
                                        return null;
                                    }
                                } else {
                                    return teamIdFromUrl;
                                }
                            }
                            const teamId = getTeamId();

                            return this.headerService.get(teamId).pipe(
                                tap((header: Header) => this.refreshHeaders(header))
                            );

                        }),
                    );
                }),
                takeUntilDestroyed(),
        ).subscribe();

    }

    private refreshHeaders(header: Header){
        if(header){
            this.header = header;
            this.sideHeader = {
                listenMenu: header.listenMenu,
                respondMenu: header.respondMenu,
                analyseMenu: header.analyseMenu,
                adminMenu: header.adminMenu,
            }
            this.teamMoodAdminMenu = this.header.teamMoodAdminMenu?.items
        }
    }

}